import { memo } from "react";
import PropTypes from "prop-types";
import { equals, pick } from "ramda";
import styled from "styled-components";
import { extendedSystemStyles } from "@mixins";
var styledSystemKeys = ["color", "space", "layout", "flexbox", "position"];
var Image = styled.img.withConfig({
  displayName: "Image",
  componentId: "sc-1do0ogu-0"
})(["", "", ""], function (_ref) {
  var _ref$objectFit = _ref.objectFit,
    objectFit = _ref$objectFit === void 0 ? "cover" : _ref$objectFit,
    _ref$objectPosition = _ref.objectPosition,
    objectPosition = _ref$objectPosition === void 0 ? "center" : _ref$objectPosition,
    _ref$maxHeight = _ref.maxHeight,
    maxHeight = _ref$maxHeight === void 0 ? "inherit" : _ref$maxHeight;
  return "\n    display: block;\n    width: 100%;\n    height: inherit;\n    min-height: inherit;\n    max-height: ".concat(maxHeight, ";\n    object-fit: ").concat(objectFit, ";\n    object-position: ").concat(objectPosition, ";\n  ");
}, extendedSystemStyles(styledSystemKeys));
Image.propTypes = {
  id: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  objectFit: PropTypes.oneOf(["contain", "cover"]),
  objectPosition: PropTypes.oneOf(["top", "center"]),
  style: PropTypes.object
};
export default /*#__PURE__*/memo(Image, function (prev, curr) {
  return equals(pick(["src", "alt"], prev), pick(["src", "alt"], curr));
});